import { getWidgetChannelInfo } from './utils/getWidgetChannel.js'
import { widgetStore } from '../store/widgetStore.js'

export const widgetManager = {
  // Core controls
  openWidget: () => widgetStore.getState().openWidget(),
  closeWidget: (minimize = false) => widgetStore.getState().closeWidget(minimize),

  // Icon visibility
  showIcon: () => widgetStore.getState().showIcon(),
  hideIcon: () => widgetStore.getState().hideIcon(),

  // Heads-up display
  openHeadsup: () => widgetStore.getState().openHeadsup(),
  closeHeadsup: (closedByUser = false) => widgetStore.getState().closeHeadsup(closedByUser),

  // Tab/Channels changes logic
  setWidgetTab: (tab = null) => widgetStore.getState().setWidgetTab(tab),
  openChannel: (channelId) => widgetStore.getState().openChannel(channelId),

  // Interest actions
  showAnimation: (type = 'pulse') => widgetStore.getState().showAnimation(type),
  playSound: (type = 'notification') => widgetStore.getState().playSound(type),

  // Generic state setter
  setState: (state) => widgetStore.getState().setState(state),

  // State access + subscriptions
  subscribe: (...args) => widgetStore.subscribe(...args),

  isWidgetActive: () => {
    const { widget_tab, widget_visibility } = widgetStore.getState()
    const [, tab, view] = widget_tab?.split('.') || []

    if ((tab === 'audio' || tab === 'video') && (view === 'ringing' || view === 'in-progress')) {
      return true
    }

    return widget_visibility
  },

  getState: () => widgetStore.getState(),
  getWidgetTab: () => widgetStore.getState().widget_tab,
  getPreviousWidgetTab: () => widgetStore.getState().previous_widget_tab,
  getWidgetChannelInfo: (widget_tab) => getWidgetChannelInfo(widget_tab ?? widgetStore.getState().widget_tab),
  isIconVisible: () => widgetStore.getState().icon_visibility,
  isHeadsUpVisible: () => widgetStore.getState().headsup_visibility,
  isWidgetVisible: () => widgetStore.getState().widget_visibility,
}
